'use client';

import { cn } from '@/utils/cn';

const MenuButton = ({
  isOpen,
  onClick,
  openLabel,
  closeLabel,
  className,
}: MenuButtonProps) => {
  return (
    <button
      type="button"
      aria-label={isOpen ? closeLabel : openLabel}
      aria-expanded={isOpen}
      onClick={onClick}
      className={cn(
        'fixed right-5 top-5 z-[70] flex size-[50px] items-center justify-center',
        'text-primary',
        className,
      )}
    >
      <span className="relative flex flex-col gap-[6px] w-[22px]">
        <span
          className={cn(
            'block h-[2px] w-full bg-current rounded-sm transition-transform duration-300 origin-center',
            isOpen && 'translate-y-[8px] rotate-45',
          )}
        />
        <span
          className={cn(
            'block h-[2px] w-full bg-current rounded-sm transition-opacity duration-200',
            isOpen && 'opacity-0',
          )}
        />
        <span
          className={cn(
            'block h-[2px] w-full bg-current rounded-sm transition-transform duration-300 origin-center',
            isOpen && '-translate-y-[8px] -rotate-45',
          )}
        />
      </span>
    </button>
  );
};

export default MenuButton;

type MenuButtonProps = {
  isOpen: boolean;
  onClick: () => void;
  openLabel: string;
  closeLabel: string;
  className?: string;
};
